import { render, staticRenderFns } from "./open.vue?vue&type=template&id=624b8cde&scoped=true"
import script from "./open.vue?vue&type=script&lang=js"
export * from "./open.vue?vue&type=script&lang=js"
import style0 from "./open.vue?vue&type=style&index=0&id=624b8cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b8cde",
  null
  
)

export default component.exports